import { arSA, az, de, enUS, ru, tr } from "react-day-picker/locale";

/**
 * next-intl locale (ör. "tr", "en", "en-US") -> react-day-picker locale objesi
 * @param {string} appLocale
 * @returns {object} react-day-picker locale
 */
export function getDayPickerLocale(appLocale) {
  const base = String(appLocale ?? "tr").split("-")[0];

  if (base === "tr") return tr;
  if (base === "ar") return arSA;
  if (base === "de") return de;
  if (base === "en") return enUS;
  if (base === "ru") return ru;
  if (base === "az") return az;

  return tr;
}

/**
 * next-intl locale -> DayPicker weekStartsOn
 * @param {string} appLocale
 * @returns {number} 0..6 (Sunday..Saturday)
 */
export function getWeekStartsOn(appLocale) {
  const dayPickerLocale = getDayPickerLocale(appLocale);
  return dayPickerLocale?.options?.weekStartsOn ?? 1;
}

